/**
 * TransformIcon/index.js
 * desc: system icon for transform step type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const TransformIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="transform icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.transform.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg"><path d="M20 15v2h-4v2h2l-3 3-3-3h2v-2H6c-1.1 0-2-.9-2-2V7H0V5h4V3H2l3-3 3 3H6v12h14zm-6-8H8V5h6c1.1 0 2 .9 2 2v6h-2V7z"/></svg>
    </IconButton>
);


export default TransformIcon;
